import styled from 'styled-components';

import Icon from 'web-components/Icon';
import Button from 'web-components/Button';

import {
  Flex,
  Text,
} from 'web-styled';

export const Checkout = styled(Flex).attrs({
  column: true,
  spacing: 20,
})`

  hr {
    border-bottom: 1px solid #c2c2c2;
  }
`;

export const Item = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  justify: 'space-between',
})`
  padding: 15px;
  border-radius: 10px;
  background: #F4F4F4;
`;

export const RemoveItem = styled(Text).attrs({
  as: 'div',
  color: '#b64135',
})`
  font-size: 13px;
  cursor: pointer;
`;

export const CheckCircle = styled(Icon).attrs<{ type?: string, isDefault?: boolean }>(
  props => ({
    type: `far fa-${props.isDefault ? 'check-' : ''}circle`,
    color: props.isDefault ? props.theme.colors.primary : '#8e8e8e',
  }),
)``;

export const LinkButton = styled(Button).attrs({
  appearance: 'link',
})`
  color: ${props => props.theme.colors.primary} !important;
  font-size: 15px;
  font-weight: 300;
`;

export const Subscribe = styled(Button).attrs({
  type: 'button',
  appearance: 'success',
})`
  display: block;
  font-size: 16px;
  padding: 10px 45px;
  border-radius: 50px;
  transition: all 0.2s linear;
`;
